import * as React from "react"

const ContractIllustration2 = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500">
    <path
      d="M392.07 242.47h35.16v11.19h-35.16z"
      style={{
        fill: "#ebebeb",
      }}
      transform="rotate(180 409.65 248.06)"
    />
    <path
      d="M411.68 267.77c5.84-.1 20.81-.35 26.45-.42h8.71l-.46.46v-11.19l.5.5c-5.84 0-20.73-.08-26.37-.16l-8.79-.11.24-.23-.24 11.19Zm0 0-.23-11.19v-.24h.24c4.39-.06 13.2-.16 17.58-.19l17.58-.07h.5v12.15H438.03c-5.6-.06-20.5-.31-26.29-.41ZM201.58 425.63c5.83-.1 20.81-.35 26.44-.41l8.71-.05-.45.46-.05-11.19.5.5-17.58-.07c-4.37 0-13.2-.13-17.57-.19l.23-.24-.23 11.19Zm0 0-.24-11.19v-.23h.25c4.38-.06 13.19-.16 17.57-.19l17.58-.07h.5v12.15h-9.33c-5.6-.06-20.5-.31-26.28-.41ZM221.19 439.74c5.84-.1 20.81-.35 26.44-.41l8.71-.05-.45.46v-11.19l.49.5c-5.83 0-20.72-.07-26.36-.15l-8.79-.11.23-.24-.23 11.19Zm0 0-.19-11.19v-.23h.25c4.38-.06 13.19-.16 17.58-.19l17.57-.07h.51v12.15h-.46l-8.86-.05c-5.6-.06-20.51-.31-26.29-.41Z"
      style={{
        fill: "#ebebeb",
      }}
    />
    <path
      d="M240.72 414.44h35.16v11.19h-35.16z"
      style={{
        fill: "#ebebeb",
      }}
      transform="rotate(180 258.3 420.035)"
    />
    <path
      d="M53.16 256.58h35.16v11.19H53.16z"
      style={{
        fill: "#ebebeb",
      }}
      transform="rotate(180 70.74 262.17)"
    />
    <path
      d="M72.77 44.93h35.16v11.19H72.77z"
      style={{
        fill: "#ebebeb",
      }}
      transform="rotate(180 90.35 50.53)"
    />
    <path
      d="M53.16 70.23c5.84-.1 20.81-.35 26.45-.41h8.71l-.46.45V59.08l.5.5c-5.84 0-20.73-.07-26.37-.15l-8.79-.11.2-.32-.24 11.19Zm0 0L52.92 59v-.23h.24c4.39-.06 13.19-.16 17.58-.2l17.58-.07h.5v12.15H79.5c-5.6-.07-20.51-.32-26.29-.42ZM392.07 56.12c5.84-.1 20.81-.34 26.45-.41h8.71l-.46.45V44.97l.5.5-17.58-.07c-4.38 0-13.2-.13-17.58-.19l.24-.24-.24 11.19Zm0 0-.24-11.19v-.23h.24c4.39-.06 13.2-.16 17.58-.2l17.58-.07h.5v.5l-.05 11.19v.46H418.36c-5.6-.07-20.5-.32-26.29-.42ZM447.63 129.13c-19.06.69-44.25 1.89-63.17 2.1-.51-18.57-.53-44.44-.64-63.26V65.3h2.67c18.91.14 44.6.13 63.26.64-.2 18.84-1.38 44.21-2.11 63.18Zm0 0c-.74-17.84-1.73-43.68-2.07-61.16l2.07 2.03c-17.68.37-43.21.55-61.15.59l2.65-2.59c0 18-.21 43.38-.59 61.16l-2.06-2.07c17.38.34 43.42 1.36 61.15 2.07Z"
      style={{
        fill: "#ebebeb",
      }}
    />
    <path
      d="M394.35 95.79c2 1.64 3.84 3.35 5.69 5.07s3.64 3.51 5.46 5.26c3.58 3.55 7 7.19 10.45 10.88l-6.11.39a240.25 240.25 0 0 1 16.58-29.08c3.09-4.66 6.35-9.2 9.85-13.61A126.4 126.4 0 0 1 447.63 62a126.06 126.06 0 0 1-5.93 16 192.07 192.07 0 0 1-7.46 15 241 241 0 0 1-18 28.21l-3.34 4.48-2.77-4.09c-2.82-4.15-5.59-8.35-8.23-12.64-1.29-2.17-2.63-4.3-3.88-6.51s-2.52-4.38-3.67-6.66Z"
      style={{
        fill: "#c7c7c7",
      }}
    />
    <path
      d="M307.37 300v162.2h98V300Zm89.14 102.32h-80.24v-42.19h80.24Zm0-52.27h-80.24v-42.2h80.24Z"
      style={{
        fill: "#dbdbdb",
      }}
    />
    <path
      d="M405.41 300.02h44.33v162.17h-44.33zM316.27 307.85h19.07v42.22h-19.07zM396.76 452.26h-80.24v-40.75h80.24Zm-79.74-.5h79.24V412H317Z"
      style={{
        fill: "#ebebeb",
      }}
    />
    <path
      d="M348.72 423.09h15.84v5.79h-15.84zM316.27 360.13h19.07v42.22h-19.07z"
      style={{
        fill: "#ebebeb",
      }}
    />
    <path
      d="M359.37 376.18h38.92v13.41h-38.92z"
      style={{
        fill: "#a6a6a6",
      }}
      transform="rotate(90 378.825 382.885)"
    />
    <path
      d="M374.63 385.19h8.4v13.41h-8.4z"
      style={{
        fill: "#dbdbdb",
      }}
      transform="rotate(90 378.825 391.895)"
    />
    <path
      d="M376.34 371.74h4.98v13.41h-4.98z"
      style={{
        fill: "#dbdbdb",
      }}
      transform="rotate(90 378.825 378.445)"
    />
    <path
      d="M339.67 317.5h33.9v32.57h-33.9z"
      style={{
        fill: "#ebebeb",
      }}
    />
    <path
      d="M373.57 317.5h12.88v32.57h-12.88zM339.67 333.79h33.9l-26.48.83-7.42-.83zM373.57 346.14h-33.9l26.47.84 7.43-.84zM339.67 324.68h21.47l-19.09.69-2.38-.69zM373.57 341.34H352.1l19.08.69 2.39-.69zM347.8 321.06h24.22l-4.04.41-20.18-.41zM342.96 337.28h24.22l-4.03.41-20.19-.41z"
      style={{
        fill: "#c7c7c7",
      }}
    />
    <path
      d="M357.86 327.78h15.71l2.81 1.1-18.52-1.1zM335.34 327.78h15.71l2.81 1.1-18.52-1.1zM355.5 342.42h-15.71l-2.81 1.1 18.52-1.1z"
      style={{
        fill: "#ebebeb",
      }}
    />
    <path
      d="M373.57 338.7h12.61l2.81 1.1-15.42-1.1zM377.97 333.79h9.78l-1.3-.9-8.48.9z"
      style={{
        fill: "#c7c7c7",
      }}
    />
    <path
      d="M385.53 360.82h10.98v41.52h-10.98z"
      style={{
        fill: "#ebebeb",
      }}
    />
    <path
      d="M391 369a2.29 2.29 0 1 1 2.29-2.28A2.28 2.28 0 0 1 391 369Z"
      style={{
        fill: "#fff",
      }}
    />
    <path
      d="M391 368a1.31 1.31 0 1 1 1.31-1.3A1.31 1.31 0 0 1 391 368Z"
      style={{
        fill: "#a6a6a6",
      }}
    />
    <path
      d="M385.97 385.26h10.1v10.98h-10.1z"
      style={{
        fill: "#fff",
      }}
      transform="rotate(90 391.02 390.75)"
    />
    <path
      d="M330.6 393.77h41.52v8.63H330.6z"
      style={{
        fill: "#c7c7c7",
      }}
    />
    <path
      d="M363.93 398.09a2.29 2.29 0 1 1 2.28 2.28 2.29 2.29 0 0 1-2.28-2.28Z"
      style={{
        fill: "#fff",
      }}
    />
    <path
      d="M364.91 398.09a1.31 1.31 0 1 1 1.3 1.31 1.31 1.31 0 0 1-1.3-1.31Z"
      style={{
        fill: "#a6a6a6",
      }}
    />
    <path
      d="M337.14 393.77h10.1v8.63h-10.1z"
      style={{
        fill: "#fff",
      }}
      transform="rotate(180 342.19 398.09)"
    />
    <path
      d="M138.73 73.3h251.92v334.62H138.73z"
      style={{
        fill: "#ffc727",
      }}
    />
    <g
      style={{
        opacity: 0.30000000000000004,
      }}
    >
      <path
        d="M138.73 73.3h251.92v334.62H138.73z"
        style={{
          fill: "#020100",
        }}
      />
    </g>
    <path
      d="M131.88 73.3H383.8v334.62H131.88z"
      style={{
        fill: "#ffc727",
      }}
    />
    <g
      style={{
        opacity: 0.2,
      }}
    >
      <path
        d="M131.88 73.3H383.8v334.62H131.88z"
        style={{
          fill: "#020100",
        }}
      />
    </g>
    <path
      d="M149.44 88.06h222.4v301.48h-222.4z"
      style={{
        fill: "#ebebeb",
      }}
      transform="rotate(-.73 260.634 238.699)"
    />
    <path
      d="M106.48 127.6h301.48V350H106.48z"
      style={{
        fill: "#dbdbdb",
      }}
      transform="rotate(-88.76 257.23 238.799)"
    />
    <path
      d="M146.02 88.06h222.4v301.48h-222.4z"
      style={{
        fill: "#fff",
      }}
    />
    <path
      d="M368.42 389.54c-.19.06-222.45.18-222.63.23s-.11-301.6-.15-301.71v-.37h.36c.23-.06 222.45.15 222.66.1.09.27-.33 301.47-.26 301.75Zm0 0-.27-301.48c1.83.51-222.61.3-222.13.38l.37-.38-.14 301.48c-1.55-.31 222.56 0 222.17 0Z"
      style={{
        fill: "#dbdbdb",
      }}
    />
    <path
      d="M326.4 184.58a52.17 52.17 0 0 1 14.66 0 52.55 52.55 0 0 1-14.66 0ZM293.12 184.58a199.34 199.34 0 0 1 28.5 0 199.34 199.34 0 0 1-28.5 0ZM233.59 184.58c17.37-.67 34.87-.67 52.25 0-17.38.67-34.88.67-52.25 0ZM174.23 184.58c17.92-.67 36-.67 53.9 0-17.93.67-36 .67-53.9 0ZM318.75 197.46a120.48 120.48 0 0 1 22.31 0 121.36 121.36 0 0 1-22.31 0ZM252.31 197.46c19.56-.68 39.25-.68 58.81 0-19.56.67-39.25.67-58.81 0ZM215.51 197.46a223.78 223.78 0 0 1 30.42 0 227.06 227.06 0 0 1-30.42 0ZM174.23 197.46a304.67 304.67 0 0 1 35.5 0 309.14 309.14 0 0 1-35.5 0ZM312.25 210.33a203.69 203.69 0 0 1 28.81 0 203.69 203.69 0 0 1-28.81 0ZM272 210.33a282.09 282.09 0 0 1 33.91 0 282.09 282.09 0 0 1-33.91 0ZM206.68 210.33c19.66-.67 39.46-.67 59.13 0-19.67.67-39.47.67-59.13 0ZM174.23 210.33a158.13 158.13 0 0 1 25.38 0 158.13 158.13 0 0 1-25.38 0ZM323.49 223.21a74.83 74.83 0 0 1 17.57 0 75.37 75.37 0 0 1-17.57 0ZM292.32 223.21a156.27 156.27 0 0 1 25.23 0 156.27 156.27 0 0 1-25.23 0ZM246.69 223.21a375.92 375.92 0 0 1 39.15 0 375.92 375.92 0 0 1-39.15 0ZM219.85 223.21a93.15 93.15 0 0 1 19.61 0 93.82 93.82 0 0 1-19.61 0ZM174.23 223.21a349.54 349.54 0 0 1 37.75 0 349.54 349.54 0 0 1-37.75 0ZM312.25 236.09a200.75 200.75 0 0 1 28.81 0 203.69 203.69 0 0 1-28.81 0ZM281.72 236.09a152 152 0 0 1 25.06 0 154.18 154.18 0 0 1-25.06 0ZM254.85 236.09a109.23 109.23 0 0 1 21.24 0 110 110 0 0 1-21.24 0ZM205.2 236.09c14.7-.69 29.51-.69 44.22 0-14.71.68-29.52.68-44.22 0ZM174.23 236.09a140.43 140.43 0 0 1 24.09 0 141.46 141.46 0 0 1-24.09 0ZM277.54 249a218.35 218.35 0 0 1 29.83 0 216.76 216.76 0 0 1-29.83 0ZM243.15 249a204.11 204.11 0 0 1 28.85 0 202.63 202.63 0 0 1-28.84 0ZM219.85 249a76.31 76.31 0 0 1 17.68 0 75.76 75.76 0 0 1-17.68 0ZM174.23 249a373.62 373.62 0 0 1 39 0 370.9 370.9 0 0 1-39 0ZM322.69 274.72a81.77 81.77 0 0 1 18.37 0 82.36 82.36 0 0 1-18.37 0ZM302.64 274.72a63 63 0 0 1 16.11 0 63.4 63.4 0 0 1-16.11 0ZM263.4 274.72a277.85 277.85 0 0 1 33.9 0 281.92 281.92 0 0 1-33.9 0ZM238.17 274.72a87.92 87.92 0 0 1 19.05 0 88.55 88.55 0 0 1-19.05 0ZM202.82 274.72a204.52 204.52 0 0 1 29.08 0 207.52 207.52 0 0 1-29.08 0ZM174.23 274.72a115.47 115.47 0 0 1 21.84 0 116.31 116.31 0 0 1-21.84 0ZM309.35 287.59a246.71 246.71 0 0 1 31.71 0 243.14 243.14 0 0 1-31.71 0ZM272 287.59a252.18 252.18 0 0 1 32.06 0 248.53 248.53 0 0 1-32.06 0ZM248.61 287.59a76.05 76.05 0 0 1 17.65 0 75.51 75.51 0 0 1-17.65 0ZM215.51 287.59a187.5 187.5 0 0 1 27.64 0 184.79 184.79 0 0 1-27.64 0ZM174.23 287.59a309.14 309.14 0 0 1 35.5 0 304.67 304.67 0 0 1-35.5 0ZM252.31 300.47a181.06 181.06 0 0 1 27.16 0 181.06 181.06 0 0 1-27.16 0ZM233.59 300.47a48.63 48.63 0 0 1 14.1 0 48.28 48.28 0 0 1-14.1 0ZM203.79 300.47a135.89 135.89 0 0 1 23.61 0 135.89 135.89 0 0 1-23.61 0ZM174.23 300.47a132.23 132.23 0 0 1 23.29 0 132.23 132.23 0 0 1-23.29 0ZM174.23 339.18c21.69-.67 43.53-.67 65.23 0-21.7.67-43.54.67-65.23 0ZM261.69 339.18c26-.67 53.38-.66 79.37 0-26 .66-53.4.67-79.37 0Z"
      style={{
        fill: "#c7c7c7",
      }}
    />
    <path
      d="M228.13 159.73c20.05-.67 40.23-.67 60.28 0-20.05.67-40.23.67-60.28 0ZM228.13 132.73c20.05-.67 40.23-.67 60.28 0-20.05.67-40.23.67-60.28 0ZM190.59 141a.84.84 0 0 1 .85-.85.86.86 0 0 1 .87.85v9.16a.86.86 0 0 1-.87.85.84.84 0 0 1-.85-.85ZM201.51 146.45v3.71a.81.81 0 0 1-.8.82.84.84 0 0 1-.83-.82v-3.71a1.59 1.59 0 0 0-1.61-1.57 1.55 1.55 0 0 0-1.55 1.57v3.71a.29.29 0 0 1 0 .15.85.85 0 0 1-.82.67.82.82 0 0 1-.83-.82v-6.11a.83.83 0 0 1 .83-.83.85.85 0 0 1 .76.48 3.12 3.12 0 0 1 1.64-.48 3.25 3.25 0 0 1 3.21 3.23ZM207.1 142.71v.22h.47a.85.85 0 0 1 .85.85.86.86 0 0 1-.85.86h-.47v5.47a.86.86 0 1 1-1.71 0v-5.47H205a.87.87 0 0 1-.87-.86.85.85 0 0 1 .87-.85h.4v-.22a3.26 3.26 0 0 1 .3-1.52 1.86 1.86 0 0 1 1.12-1 3.22 3.22 0 0 1 .93-.13.87.87 0 0 1 0 1.73 1.23 1.23 0 0 0-.41 0 .17.17 0 0 0-.09 0s-.15.35-.15.92ZM210.7 149.85a3.86 3.86 0 0 1-1.07-2.73 4 4 0 0 1 1.07-2.72 3.63 3.63 0 0 1 2.67-1.18 3.44 3.44 0 0 1 2.63 1.18 3.88 3.88 0 0 1 1.09 2.72 3.75 3.75 0 0 1-1.09 2.73 3.44 3.44 0 0 1-2.59 1.18 3.63 3.63 0 0 1-2.71-1.18Zm.62-2.73a2.47 2.47 0 0 0 .56 1.64 2.08 2.08 0 0 0 1.49.58 2 2 0 0 0 1.43-.58 2.51 2.51 0 0 0 0-3.26 2.22 2.22 0 0 0-1.43-.59 2.27 2.27 0 0 0-1.49.59 2.45 2.45 0 0 0-.56 1.62ZM224.15 144.05a.82.82 0 0 1-.82.82 1.49 1.49 0 0 0-.93.29 2.32 2.32 0 0 0-.71.75 4.52 4.52 0 0 0-.64 1.3v2.95a.84.84 0 0 1-.85.82.82.82 0 0 1-.82-.82v-6.11a.82.82 0 0 1 .82-.81.84.84 0 0 1 .85.81v.1a2.42 2.42 0 0 1 .33-.31 3.37 3.37 0 0 1 2-.6.8.8 0 0 1 .77.81ZM232.67 146.44v3.72a.82.82 0 0 1-.82.82.85.85 0 0 1-.84-.82v-3.72a1.58 1.58 0 0 0-3.16 0v3.79a.18.18 0 0 1 0 .1v.08a.9.9 0 0 1-.78.49h-.16a.85.85 0 0 1-.66-.81V144a.82.82 0 0 1 .82-.84.77.77 0 0 1 .74.47 3.26 3.26 0 0 1 4.1.6 3.26 3.26 0 0 1 5.67 2.19v3.68a.83.83 0 0 1-.83.82.84.84 0 0 1-.84-.82v-3.68a1.59 1.59 0 0 0-1.56-1.6 1.62 1.62 0 0 0-1.68 1.62ZM240.4 147.1a3.85 3.85 0 0 1 3.79-3.88 3.72 3.72 0 0 1 3.74 3.6v.08a.34.34 0 0 1 0 .14.74.74 0 0 1-.8.62h-4.94a2.08 2.08 0 0 0 .53 1 2.37 2.37 0 0 0 1.49.69 2.53 2.53 0 0 0 1.61-.38.88.88 0 0 1 1.18.03.72.72 0 0 1 0 1 3.92 3.92 0 0 1-2.78 1 3.85 3.85 0 0 1-3.82-3.9Zm1.69-.76h4.39a2.52 2.52 0 0 0-2.29-1.64 2.18 2.18 0 0 0-2.1 1.64ZM257.42 150.14a.84.84 0 0 1-1.66.17 3.73 3.73 0 0 1-2.11.67 3.88 3.88 0 0 1 0-7.76 3.69 3.69 0 0 1 2.08.65V141a.86.86 0 0 1 .86-.84.84.84 0 0 1 .83.84v9.18Zm-3.77-5.23a2 2 0 0 0-1.45.64 2.21 2.21 0 0 0-.63 1.57 2.15 2.15 0 0 0 .63 1.53 2 2 0 0 0 2.91 0 2.14 2.14 0 0 0 .62-1.53 2.21 2.21 0 0 0-.62-1.57 2 2 0 0 0-1.46-.64ZM265 145.4a5.69 5.69 0 0 1 5.7-5.59 5.81 5.81 0 0 1 3.58 1.21.89.89 0 0 1-1.09 1.41 3.83 3.83 0 0 0-2.49-.85 4.1 4.1 0 0 0-2.8 1.12 3.79 3.79 0 0 0 0 5.4 4.13 4.13 0 0 0 2.8 1.11 3.85 3.85 0 0 0 2.49-.85 1 1 0 0 1 1.25.17.92.92 0 0 1-.16 1.24 5.81 5.81 0 0 1-3.58 1.21 5.68 5.68 0 0 1-5.7-5.58ZM277.81 149.85a3.91 3.91 0 0 1-1.07-2.73 4 4 0 0 1 1.07-2.72 3.63 3.63 0 0 1 2.67-1.18 3.44 3.44 0 0 1 2.6 1.18 3.92 3.92 0 0 1 1.08 2.72 3.79 3.79 0 0 1-1.08 2.73 3.44 3.44 0 0 1-2.6 1.18 3.63 3.63 0 0 1-2.67-1.18Zm.62-2.73a2.52 2.52 0 0 0 .56 1.64 2.08 2.08 0 0 0 1.49.58 2 2 0 0 0 1.43-.58 2.48 2.48 0 0 0 0-3.26 2.2 2.2 0 0 0-1.43-.59 2.27 2.27 0 0 0-1.49.59 2.5 2.5 0 0 0-.56 1.62ZM293.27 146.45v3.71a.82.82 0 0 1-.81.82.84.84 0 0 1-.82-.82v-3.71a1.59 1.59 0 0 0-1.61-1.57 1.55 1.55 0 0 0-1.55 1.57v3.71a.23.23 0 0 1 0 .15.83.83 0 0 1-.82.67.82.82 0 0 1-.82-.82v-6.11a.83.83 0 0 1 .82-.83.84.84 0 0 1 .76.48 3.16 3.16 0 0 1 1.65-.48 3.25 3.25 0 0 1 3.2 3.23ZM295.94 148.76a.8.8 0 0 1 1.16-.12 2.84 2.84 0 0 0 1.71.68 2.14 2.14 0 0 0 1.06-.29.64.64 0 0 0 .27-.47.21.21 0 0 0 0-.15.51.51 0 0 0-.2-.19 3.41 3.41 0 0 0-1.25-.43 6.08 6.08 0 0 1-1.35-.41 2.57 2.57 0 0 1-1.07-.9 1.89 1.89 0 0 1-.27-1 2.19 2.19 0 0 1 .92-1.7 3.34 3.34 0 0 1 1.91-.58 4 4 0 0 1 2.33.86.85.85 0 0 1 .24 1.15.81.81 0 0 1-1.14.21 2.7 2.7 0 0 0-1.43-.57 1.54 1.54 0 0 0-.93.28.49.49 0 0 0-.25.35.18.18 0 0 0 0 .13.43.43 0 0 0 .17.15 3.3 3.3 0 0 0 1.13.38 5.33 5.33 0 0 1 1.45.45 2.38 2.38 0 0 1 1.1.92 2 2 0 0 1 .29 1 2.22 2.22 0 0 1-1 1.8 3.53 3.53 0 0 1-2 .62 4.45 4.45 0 0 1-2.76-1.07.83.83 0 0 1-.09-1.1ZM303.4 147.1a3.85 3.85 0 0 1 3.79-3.88 3.72 3.72 0 0 1 3.74 3.6v.08a.34.34 0 0 1 0 .14.74.74 0 0 1-.8.62h-4.94a2.08 2.08 0 0 0 .53 1 2.39 2.39 0 0 0 1.49.69 2.52 2.52 0 0 0 1.61-.38.88.88 0 0 1 1.18.03.72.72 0 0 1 0 1 3.92 3.92 0 0 1-2.78 1 3.85 3.85 0 0 1-3.82-3.9Zm1.69-.76h4.4a2.55 2.55 0 0 0-2.3-1.64 2.18 2.18 0 0 0-2.1 1.64ZM319.87 146.45v3.71a.82.82 0 0 1-.81.82.84.84 0 0 1-.82-.82v-3.71a1.6 1.6 0 0 0-1.62-1.57 1.55 1.55 0 0 0-1.55 1.57v3.71a.29.29 0 0 1 0 .15.85.85 0 0 1-.82.67.81.81 0 0 1-.82-.82v-6.11a.82.82 0 0 1 .82-.83.85.85 0 0 1 .76.48 3.12 3.12 0 0 1 1.64-.48 3.26 3.26 0 0 1 3.22 3.23ZM326.4 144.08a.87.87 0 0 1-.87.85h-.39v4.33a.86.86 0 0 1 .86.87.85.85 0 0 1-.86.85 1.73 1.73 0 0 1-1.72-1.72v-4.33H323a.86.86 0 0 1 0-1.71h.45V141a.85.85 0 0 1 .87-.85.84.84 0 0 1 .85.85v2.25h.39a.87.87 0 0 1 .84.83Z"
      style={{
        fill: "#ffc727",
      }}
    />
    <path
      d="M268.13 333.37c1.69-1.16 3.42-2.26 5.21-3.28a24.41 24.41 0 0 1 5.63-2.54 6.71 6.71 0 0 1 .78-.15.83.83 0 0 1 .86.28 3 3 0 0 1 .36 1.6 18.83 18.83 0 0 1-.32 3.1 61.71 61.71 0 0 1-1.42 6 91.3 91.3 0 0 1-4.09 11.62 18.85 18.85 0 0 1-1.46 2.77 3.6 3.6 0 0 1-.55.64.88.88 0 0 1-.54.24.61.61 0 0 1-.37-.13l-.19-.19a3.11 3.11 0 0 1-.43-1.65 20.72 20.72 0 0 1 1.08-6.13 36.09 36.09 0 0 1 2.32-5.74 17.58 17.58 0 0 1 3.61-5 5.75 5.75 0 0 1 2.84-1.36 3.4 3.4 0 0 1 1.61.14 2.44 2.44 0 0 1 1.13 1.16 6.91 6.91 0 0 0 .86 1.23 1.21 1.21 0 0 0 1.24.41 8.09 8.09 0 0 0 2.58-1.51c.41-.31.81-.62 1.24-.92a5 5 0 0 1 .67-.41c.22-.1.55-.28.85 0 .4.5.3 1 .5 1.49a.91.91 0 0 0 1.06.67 9.26 9.26 0 0 0 2.26-2c.69-.75 1.37-1.52 2-2.29 1.34-1.55 2.66-3.12 4-4.66.69-.76 1.39-1.52 2.13-2.23a14.5 14.5 0 0 1 1.18-1 4 4 0 0 1 .7-.41 1.06 1.06 0 0 1 .45-.1.61.61 0 0 1 .48.25 2.73 2.73 0 0 1 .21 1.64 13.35 13.35 0 0 1-.25 1.54 33.68 33.68 0 0 1-3.27 8.69 6.14 6.14 0 0 1-1 1.28 1.11 1.11 0 0 1-.9.37 2.64 2.64 0 0 1-.83-.24 3.8 3.8 0 0 1-2.06-2.51 1.38 1.38 0 0 1 .12-1 1 1 0 0 1 .39-.38 1.09 1.09 0 0 1 .53-.12 5.88 5.88 0 0 1 1.59.38c1 .35 1.93.76 2.87 1.17s1.88.83 2.82 1.21c.47.19.95.37 1.42.51a3.64 3.64 0 0 0 .68.15 1 1 0 0 0 .56-.12c.77-.39 1.29-1.35 2.06-2.1a2.55 2.55 0 0 1 1.58-.81.81.81 0 0 1 .63.21.83.83 0 0 1 .21.63 3.74 3.74 0 0 1-.15.83c-.14.47-.2 1.05-.07 1.07s.74 0 1.17-.07a7.75 7.75 0 0 0 2.59-1.35c.42-.29.83-.61 1.31-.88a2.61 2.61 0 0 1 1.71-.41 6.26 6.26 0 0 1 2.63 1.91 7.24 7.24 0 0 0 1.1.95c.18.11.35.15.39.11a3.55 3.55 0 0 0 .59-.37 23.6 23.6 0 0 0 2.32-1.94 26.85 26.85 0 0 0 4-4.57 5.19 5.19 0 0 0 1-2.66c0-.92-.95-1.34-1.93-1.49a16.7 16.7 0 0 0-6 .08 15.26 15.26 0 0 0-2.9.83 6 6 0 0 0-1.3.7c-.38.28-.72.68-.61 1a1.82 1.82 0 0 0 1 .9c.44.22.93.37 1.41.56a29 29 0 0 0 2.93.86c4 .94 8.11 1 12.2 1.17v.07c-4.09-.12-8.23 0-12.28-.9a25.82 25.82 0 0 1-3-.83 13.77 13.77 0 0 1-1.46-.57 2.11 2.11 0 0 1-1.21-1.14 1.51 1.51 0 0 1 .75-1.52 6.51 6.51 0 0 1 1.38-.78 15.18 15.18 0 0 1 3-.89 17.11 17.11 0 0 1 6.22-.17 4.31 4.31 0 0 1 1.56.53 1.88 1.88 0 0 1 .89 1.51 5.6 5.6 0 0 1-1 3.06 25.5 25.5 0 0 1-4.05 4.73 26 26 0 0 1-2.39 2 4.42 4.42 0 0 1-.72.43 1.14 1.14 0 0 1-1.06-.15 7.61 7.61 0 0 1-1.23-1.05 6.05 6.05 0 0 0-2.26-1.71c-.75-.11-1.63.6-2.44 1.18a8.62 8.62 0 0 1-2.84 1.47 2.28 2.28 0 0 1-1.82-.07 1.13 1.13 0 0 1-.35-1 5.81 5.81 0 0 1 .16-.81 4.24 4.24 0 0 0 .14-.67v-.09c0 .04 0 0-.09 0a1.86 1.86 0 0 0-1.09.59c-.7.65-1.18 1.64-2.26 2.22a1.73 1.73 0 0 1-.93.18 4.1 4.1 0 0 1-.82-.18c-.51-.15-1-.34-1.47-.53-1-.4-1.9-.82-2.83-1.24s-1.88-.83-2.82-1.17a5.56 5.56 0 0 0-1.39-.35c-.33 0-.51.27-.42.71a3.24 3.24 0 0 0 1.7 2.1 2.43 2.43 0 0 0 .65.19c.13 0 .28-.06.46-.21a5.53 5.53 0 0 0 .88-1.16 29.54 29.54 0 0 0 2.48-5.56 27.18 27.18 0 0 0 .84-2.93 11.07 11.07 0 0 0 .26-1.49 2.53 2.53 0 0 0-.11-1.37c-.15-.27-.73.07-1.1.34a11.7 11.7 0 0 0-1.15 1c-.74.7-1.44 1.44-2.13 2.2-1.38 1.51-2.72 3.07-4.07 4.61-.68.77-1.36 1.54-2.07 2.28a9.31 9.31 0 0 1-2.38 2 1.15 1.15 0 0 1-1.32-.81c-.2-.48-.18-1.09-.45-1.39-.13-.12-.38 0-.59.08a4.85 4.85 0 0 0-.64.4c-.41.29-.81.61-1.22.93a8.28 8.28 0 0 1-2.68 1.59 1.57 1.57 0 0 1-1.54-.48 7.87 7.87 0 0 1-.91-1.28c-.27-.42-.54-.87-1-1a3.13 3.13 0 0 0-1.43-.1 5.32 5.32 0 0 0-2.63 1.3 17 17 0 0 0-3.46 4.94 35.49 35.49 0 0 0-2.22 5.69 20.06 20.06 0 0 0-1 5.95 2.51 2.51 0 0 0 .32 1.29l.09.09a.46.46 0 0 0 .14-.09 3.44 3.44 0 0 0 .44-.53 19.84 19.84 0 0 0 1.42-2.66 90.11 90.11 0 0 0 4.18-11.53 58 58 0 0 0 1.47-5.95 18.15 18.15 0 0 0 .35-3 2.71 2.71 0 0 0-.27-1.37c-.13-.15-.24-.2-.52-.14a4.66 4.66 0 0 0-.73.13 27 27 0 0 0-5.61 2.39q-2.7 1.45-5.28 3.14Z"
      style={{
        fill: "#263238",
      }}
    />
    <path
      d="M223.9 321.6a1.26 1.26 0 0 1-1.37-1.05 1.29 1.29 0 0 1 .14-.8 1.25 1.25 0 0 0-1.29-1.84h-.18a1.25 1.25 0 0 1-1.61-1 1.23 1.23 0 0 1 0-.57 1.25 1.25 0 0 0-1.39-1.6 1.32 1.32 0 0 0-.42.15 1.26 1.26 0 0 1-1.86-.88 1.58 1.58 0 0 1 0-.31 1.26 1.26 0 0 0-2.08-1.05 1.25 1.25 0 0 1-2.06-.72v-.05a1.25 1.25 0 0 0-2.25-.59 1.21 1.21 0 0 1-.79.49 1.25 1.25 0 0 1-1.4-.83 1.23 1.23 0 0 0-1.39-.81 1.21 1.21 0 0 0-.93.71 1.25 1.25 0 0 1-2.21.13 1.23 1.23 0 0 0-1.28-.59 1.24 1.24 0 0 0-1 1 1.25 1.25 0 0 1-1 1 1.23 1.23 0 0 1-1.12-.39 1.21 1.21 0 0 0-1.11-.37 1.23 1.23 0 0 0-1.05 1.22 1.25 1.25 0 0 1-1.06 1.23 1.18 1.18 0 0 1-.91-.22 1.26 1.26 0 0 0-1.95 1.25 1.25 1.25 0 0 1-1.71 1.4 1.25 1.25 0 0 0-1.72 1.34 1.11 1.11 0 0 0 .09.31 1.25 1.25 0 0 1-.94 1.74 1.31 1.31 0 0 1-.44 0 1.26 1.26 0 0 0-1.48 1.44 1.19 1.19 0 0 0 .22.52 1.25 1.25 0 0 1-.8 2h-.19a1.26 1.26 0 0 0-1.21 1.46 1.17 1.17 0 0 0 .4.72 1.29 1.29 0 0 1 .39.71 1.26 1.26 0 0 1-1 1.43 1.24 1.24 0 0 0-.94 1.44 1.21 1.21 0 0 0 .59.86l2.34-.39a19.4 19.4 0 0 1 36.66-6l2.34-.39a1.19 1.19 0 0 0 .28-1 1.25 1.25 0 0 0-1.31-1.1Zm.54 13.47a19.4 19.4 0 0 1-36.67 6l-2.34.39a1.18 1.18 0 0 0-.29 1 1.24 1.24 0 0 0 1.36 1.05 1.26 1.26 0 0 1 1.36 1.05 1.29 1.29 0 0 1-.14.81 1.24 1.24 0 0 0 1.28 1.83h.19a1.27 1.27 0 0 1 1.62 1 1.21 1.21 0 0 1-.05.56 1.25 1.25 0 0 0 1.39 1.6 1.16 1.16 0 0 0 .43-.15 1.26 1.26 0 0 1 1.86.88 1.08 1.08 0 0 1 0 .31 1.26 1.26 0 0 0 1.45 1.36 1.3 1.3 0 0 0 .62-.31 1.24 1.24 0 0 1 2.06.73v.05a1.25 1.25 0 0 0 2.26.58 1.22 1.22 0 0 1 .79-.48 1.25 1.25 0 0 1 1.4.82 1.24 1.24 0 0 0 2.31.1 1.26 1.26 0 0 1 2.22-.12 1.25 1.25 0 0 0 1.27.58 1.21 1.21 0 0 0 1-1 1.23 1.23 0 0 1 1-1 1.21 1.21 0 0 1 1.1.37 1.27 1.27 0 0 0 1.11.39 1.25 1.25 0 0 0 1.06-1.24 1.28 1.28 0 0 1 1.06-1.22 1.17 1.17 0 0 1 .91.21 1.25 1.25 0 0 0 2-1.22 1.26 1.26 0 0 1 1-1.49 1.35 1.35 0 0 1 .68.08 1.26 1.26 0 0 0 1.74-1.34 1.24 1.24 0 0 0-.1-.31 1.26 1.26 0 0 1 .94-1.74 1.31 1.31 0 0 1 .44 0 1.24 1.24 0 0 0 1.47-1.43 1.39 1.39 0 0 0-.22-.53 1.26 1.26 0 0 1 .82-2h.18a1.25 1.25 0 0 0 1.22-1.45 1.22 1.22 0 0 0-.4-.72 1.25 1.25 0 0 1 .56-2.15 1.25 1.25 0 0 0 .35-2.3Z"
      style={{
        fill: "#ffc727",
      }}
    />
    <path
      d="m187.83 329.87-.49-.08a18.08 18.08 0 0 1 33.88-5.58l-.45.23a17.57 17.57 0 0 0-32.94 5.43ZM205.17 350.66a18 18 0 0 1-16-9.7l.44-.23a17.57 17.57 0 0 0 32.92-5.43l.49.08a18 18 0 0 1-14.91 15 17.48 17.48 0 0 1-2.94.28ZM184.05 338.42l-.06-.22c-.17-.63-.31-1.3-.44-2.05a20.78 20.78 0 0 1-.24-2.08v-.22h.23l42.83-7.06.05.22a20.13 20.13 0 0 1 .44 2c.12.75.2 1.44.25 2.09v.23h-.22Zm-.23-4.15c.05.56.12 1.15.23 1.79s.22 1.24.36 1.79l42.16-6.94c0-.57-.12-1.17-.22-1.82-.11-.64-.23-1.22-.37-1.77Z"
      style={{
        fill: "#ffc727",
      }}
    />
    <path
      d="M218.82 69.29h78.9v29.74h-78.9zM282.39 56.14h-49l-2.17 13.15h54Zm-24.12 9.46a2.89 2.89 0 1 1 2.88-2.89 2.89 2.89 0 0 1-2.88 2.89Z"
      style={{
        fill: "#c7c7c7",
      }}
    />
    <path
      d="M285.29 69.29h-54.03l.48-2.95h52.89l.66 2.95z"
      style={{
        fill: "#a6a6a6",
      }}
    />
    <path
      d="M50.26 462.2c128-.62 271.52-.62 399.48 0-128 .61-271.52.61-399.48 0Z"
      style={{
        fill: "#263238",
      }}
    />
    <path
      d="M98.27 139.77C102 155 110.43 183 115.4 189.86c2.67 3.71 35.95 18.92 38.4 16 2.7-3.27 7.32-28.89 3.27-29.49-6.35-1-24.47-6.79-25.84-7.63-2.36-1.44-17.79-27.71-21.89-33.1-8.84-11.64-12.9-3.32-11.07 4.13Z"
      style={{
        fill: "#ad6359",
      }}
    />
    <path
      d="M129.47 255.39s-6.11 19.88-19.32 14.61-4-23.89-4-23.89Z"
      style={{
        fill: "#ffc727",
      }}
    />
    <path
      d="M129.47 255.39s-6.11 19.88-19.32 14.61-4-23.89-4-23.89Z"
      style={{
        fill: "#fff",
        opacity: 0.6000000000000001,
      }}
    />
    <path
      d="m178.16 129.64-2.08-20.24-5.78-2.31-15.43 13.26-49 126.54 23.3 9.28Z"
      style={{
        fill: "#ffc727",
      }}
    />
    <g
      style={{
        opacity: 0.6000000000000001,
      }}
    >
      <path
        d="m178.16 129.64-2.08-20.24-5.78-2.31-15.43 13.26-49 126.54 23.3 9.28Z"
        style={{
          fill: "#fff",
        }}
      />
    </g>
    <path
      d="M103.66 246.64h29.28v5.81h-29.28z"
      style={{
        fill: "#ffc727",
      }}
      transform="rotate(-158.27 118.309 249.546)"
    />
    <path
      d="M103.66 246.64h29.28v5.81h-29.28z"
      style={{
        opacity: 0.2,
      }}
      transform="rotate(-158.27 118.309 249.546)"
    />
    <path
      d="M106.04 240.67h29.28v5.81h-29.28z"
      style={{
        fill: "#ffc727",
      }}
      transform="rotate(-158.27 120.683 243.579)"
    />
    <path
      d="M106.04 240.67h29.28v5.81h-29.28z"
      style={{
        opacity: 0.2,
      }}
      transform="rotate(-158.27 120.683 243.579)"
    />
    <path
      d="m135.36 246.3-8.78-3.5 19.66-35.08 3.16 1.47-14.04 37.11z"
      style={{
        fill: "#ffc727",
      }}
    />
    <path
      d="m135.36 246.3-8.78-3.5 19.66-35.08 3.16 1.47-14.04 37.11z"
      style={{
        opacity: 0.2,
      }}
    />
    <path
      d="m171.09 107.39 1.89-1.63a1.06 1.06 0 0 1 1.76.69L175 109Z"
      style={{
        fill: "#ffc727",
      }}
    />
    <path
      d="m171.09 107.39 1.89-1.63a1.06 1.06 0 0 1 1.76.69L175 109Z"
      style={{
        opacity: 0.5,
      }}
    />
    <path
      d="M156 120.84a122.26 122.26 0 0 1 20.87 8.21 122.76 122.76 0 0 1-20.87-8.21Z"
      style={{
        opacity: 0.2,
      }}
    />
    <path
      d="M162.4 174.8c1.32 4.11 5.32 9.53 5.28 12.74a3.68 3.68 0 0 1-2.53 3.59s2.94 2 2.43 4.9c-.26 1.5-2.89 2.39-2.89 2.39s2.3 1.7 1.68 4.25c-.49 2-3.05 2.63-3.05 2.63s1.45 2.66.28 4.57c-2.37 3.89-20.21 1.54-22.11-5.39-.88-3.24 3.45-2.43 3.45-2.43s-5.94-2.66-5.55-6.36 6-2.3 6-2.3-5.74-2.63-5-6.42c.82-3.94 6.15-1.6 6.15-1.6s-3.62-3.21-2.35-6c2.09-4.56 8.82 2.41 12.87 2l3-6.18Z"
      style={{
        fill: "#ad6359",
      }}
    />
    <path
      d="M165.23 180.89c-.91-4 4.43-8.09 4.1-12-.44-5.35-7-1-9.26 6.36l-.77 6Z"
      style={{
        fill: "#ad6359",
      }}
    />
    <path
      d="M162.93 205.46v.09A31.19 31.19 0 0 1 144.7 202c-.18-.1-.09-.43.12-.36a63.84 63.84 0 0 0 18.11 3.82ZM164.78 198.47c.07 0 .06.12 0 .13-6.25.64-13.94-.85-19.66-5.07-.2-.15-.23-.47 0-.32 4.02 2.52 13.88 4.99 19.66 5.26ZM146.22 184.93c5.64 3.84 11.95 5.49 18.67 6.24.09 0 .07.13 0 .15-3.39.52-7.62-.41-10.86-1.41a18 18 0 0 1-7.94-4.78c-.09-.13 0-.28.13-.2Z"
      style={{
        fill: "#263238",
      }}
    />
    <path
      d="M178.74 461.83c-2.42.76-73-.77-75.57-2.49-1-.63 5-67.48 5-67.48l44.76.85-5.09 44.72s26 12.34 28.68 14.53 4.63 9.13 2.22 9.87Z"
      style={{
        fill: "#ad6359",
      }}
    />
    <path
      d="M178.74 461.83c-2.42.76-73-.77-75.57-2.49-.31-.19-.41-7 .72-15.82 12.79 2.15 58.47 9.16 62 7.07 2.48-1.46.28-3.74-1.75-5.27 5.83 2.9 11.28 5.7 12.4 6.64 2.65 2.18 4.61 9.13 2.2 9.87Z"
      style={{
        fill: "#263238",
      }}
    />
    <path
      d="M140.31 461.5c-18-.51-35.87-1.31-37.14-2.16-.31-.19-.4-7 .72-15.82 3 .51 8 1.3 13.71 2.17Z"
      style={{
        opacity: 0.1,
      }}
    />
    <path
      d="m149.15 426.71-43.94-.62s8.71-105.24 8.35-107.26C113.09 316.23 81.92 194 81.92 194h41.93s33.07 113.94 34.26 124.92c1.89 17.71-8.96 107.79-8.96 107.79Z"
      style={{
        fill: "#37474f",
      }}
    />
    <path
      d="M109.16 416.17c2.6-.19 5.22-.15 7.83-.19s5.21 0 7.81 0c5.22.06 10.42.13 15.63.28 1.43 0 2.85.09 4.28.15s3 .33 4.56.39a.09.09 0 1 1 0 .18c-1.28 0-2.56.21-3.84.24s-2.66.05-4 .05h-7.82c-5.21 0-10.42-.11-15.62-.33-2.94-.12-5.92-.16-8.84-.45a.14.14 0 0 1 .01-.32ZM91.14 203.87c3.75 13.28 7.18 26.69 10.55 40.08s6.71 26.8 10 40.21l5 20.11c1.62 6.53 3.5 13.09 3.91 19.83s-.47 13.77-1 20.59-1.16 13.73-1.76 20.59c-1.2 13.72-2.36 27.46-3.85 41.15-.18 1.72-.37 3.43-.54 5.15 0 .14-.24.14-.23 0 .91-13.73 1.85-27.46 3-41.18q.82-10.29 1.68-20.58c.56-6.85 1.36-13.72 1.57-20.59s-1-13.57-2.72-20.27-3.28-13.12-4.93-19.68q-5-20.1-10-40.21C98 234.05 94.3 219 91 203.9a.06.06 0 0 1 .14-.03Z"
      style={{
        fill: "#263238",
      }}
    />
    <path
      d="M81.91 194s13.38 52.44 22.74 89.35L122.49 194Z"
      style={{
        opacity: 0.1,
      }}
    />
    <path
      d="M126 462c-2.42.75-73-.77-75.57-2.49-1-.64 2.7-67.53 2.7-67.53l44.17.86-2.14 44.75s26 12.34 28.67 14.53 4.62 9.13 2.17 9.88Z"
      style={{
        fill: "#ad6359",
      }}
    />
    <path
      d="M126 462c-2.41.75-73-.77-75.56-2.5-.32-.19-.24-6.8 0-15.83 12.8 2.15 59.19 9.17 62.75 7.08 2.48-1.46.28-3.74-1.75-5.27 5.83 2.91 11.27 5.7 12.4 6.64 2.64 2.18 4.61 9.13 2.16 9.88Z"
      style={{
        fill: "#263238",
      }}
    />
    <path
      d="M122.5 194s-1.22 20.05-6 35.88c-.39 1.31-.8 2.6-1.25 3.83a75.55 75.55 0 0 0-12.17 6.06s-3 76.7-3 81.47c.2 17.82-4.36 104.61-4.36 104.61l-44.31-.42s4.6-98.15 4.62-104.68c0-6.31 3-46.14 5.68-80.67 0 0-3.94-11-3.5-16.6C59.3 210 65.35 194 65.35 194Z"
      style={{
        fill: "#37474f",
      }}
    />
    <path
      d="M112.82 220.91c.17-1.11.33-2.22.5-3.33.32-2 .73-4.05 1.09-6.08.8-4.59 1.64-9.2 2.67-13.76 0-.11.21-.08.19 0-.18 1.83-.39 3.67-.65 5.5s-.44 3.67-.7 5.5c-.51 3.63-1 7.27-1.63 10.88-.24 1.39-1.11 3.89.9 4.32 1.58.34 2.75-1.21 3.21-2.52a31.68 31.68 0 0 0 1.07-5c.33-1.84.61-3.68.87-5.52q.85-6 1.85-12c0-.12.2-.08.19 0a120.66 120.66 0 0 1-.88 12.3c-.26 1.95-.55 3.9-.89 5.84a20.26 20.26 0 0 1-1.34 5.44 4.44 4.44 0 0 1-3.27 2.72h-.1a.13.13 0 0 1 .06.11c0 .65 0 1.31-.08 2s-.19 1.28-.31 1.92a14.12 14.12 0 0 1-.5 1.91c-.11.29-.22.59-.35.88s-.35.52-.52.8c-.07.12-.21 0-.22-.07v-.38a3.64 3.64 0 0 1 0-.57c0-.31.11-.62.18-.93.14-.62.31-1.24.47-1.85s.3-1.23.46-1.84.37-1.25.51-1.88a.1.1 0 0 1 0-.06 2.91 2.91 0 0 1-2.8-1.76 5 5 0 0 1 .02-2.57ZM99.49 241.28a35.33 35.33 0 0 1 4.17-2.75 40.28 40.28 0 0 1 4.75-2.46c3.21-1.39 6.51-2.34 9.82-3.44.1 0 .16.14.07.18-3.21 1.27-6.28 3-9.37 4.48q-2.3 1.11-4.62 2.14c-1.55.68-3.1 1.48-4.7 2.07a.13.13 0 0 1-.12-.22ZM74.48 213.35a27.42 27.42 0 0 0 6.68-.9c1-.26 2-.58 3-.91a7.79 7.79 0 0 0 2.7-1.35c1.52-1.31 2.22-3.37 2.88-5.2a47.71 47.71 0 0 0 1.75-6.32.09.09 0 0 1 .18 0 24.17 24.17 0 0 1-.91 7.17c-.54 2-1.27 4.19-2.87 5.58a11.31 11.31 0 0 1-6.12 2.24 28.61 28.61 0 0 1-7.28-.1.12.12 0 0 1-.01-.21ZM53.4 416.82c2.6-.19 5.22-.15 7.83-.19s5.21 0 7.81 0c5.22.05 10.42.13 15.63.27 1.43 0 2.85.09 4.28.15s3 .33 4.56.39a.09.09 0 0 1 0 .18c-1.28 0-2.56.21-3.84.24s-2.66 0-4 0h-7.82c-5.2 0-10.42-.11-15.62-.33-2.94-.12-5.91-.16-8.84-.45a.14.14 0 0 1 .01-.26ZM58.81 411.05a.53.53 0 0 1-.51-.57l10-171.74c-.13-.76-3-10.35-3.2-15.25-.26-5.18 5.09-25.37 5.32-26.23a.54.54 0 0 1 1 .28c-.06.21-5.55 20.88-5.29 25.89s3.18 15.1 3.2 15.18-10 171.93-10 171.93a.55.55 0 0 1-.52.51ZM118 113.39a5.44 5.44 0 0 0 2.68-9.5 5 5 0 0 0 4.07-4.56 4.81 4.81 0 0 0-4.13-4.85 4.91 4.91 0 0 1 3.72 4.79 4.41 4.41 0 0 1-2.95 3.9 6 6 0 0 0 2-4.34 4.68 4.68 0 0 0-2.87-4.29 6.82 6.82 0 0 0-.13-6.16 4.66 4.66 0 0 0-4.57-2.26 5.21 5.21 0 0 0-7.75-5.62 4.37 4.37 0 0 0-5.68-4.68 3 3 0 0 0-1.91-2.55 4.91 4.91 0 0 0-3.77.32 3.52 3.52 0 0 0-3-1.47 3.19 3.19 0 0 0-2.91 2.94c-2-.46-4.34-.68-6.24.39a4.56 4.56 0 0 0-2.47 4.4 6.33 6.33 0 0 0-6.89 6.49 4.44 4.44 0 0 0-3.3 3 6.43 6.43 0 0 0-.35 3.15 3.33 3.33 0 0 0-2.39 3.07A4.36 4.36 0 0 0 70.79 99a2.5 2.5 0 0 1 0 1.13 5.78 5.78 0 0 0 1.59 5.23 3.94 3.94 0 0 0 2.11 5.53A4.42 4.42 0 0 0 78 116a6.45 6.45 0 0 0 1.73 5.09 3.75 3.75 0 0 0 3.93 1.21 2.28 2.28 0 0 0 2.27 2 5.75 5.75 0 0 0 1.24-.08 4.81 4.81 0 0 1 1.63-.22c.51.1.88.58 1.28.87a5.37 5.37 0 0 0 .93.54 5.87 5.87 0 0 0 7.06-2c1.56 1.12 3.6.66 5.17-.27a9.87 9.87 0 0 0 1.41-1.07 2.62 2.62 0 0 1 1.38-.73h1a4.07 4.07 0 0 0 2.64-1.87c4.33 2.74 9-1.47 8.33-6.08ZM69.66 96.2a3.5 3.5 0 0 1 2-3.55v.18s-.36.33-.52.5a4.3 4.3 0 0 0-.68 1.1 4.52 4.52 0 0 0-.33 2.64 5.09 5.09 0 0 0 .38 1.14l.06.14a4.21 4.21 0 0 1-.91-2.15Zm24.8-23.08a3.38 3.38 0 0 0-3.3 2h-.11c.36-1.4 1.07-2.59 2.75-2.68a2.93 2.93 0 0 1 2.62 1.34 3.78 3.78 0 0 0-1.96-.66Zm15.39 46.08a6.12 6.12 0 0 0 7.65-3.71c-.94 3.34-3.74 5.7-7.65 3.71Z"
      style={{
        fill: "#263238",
      }}
    />
    <path
      d="M124.49 194.5 119 170.19s5.8-7 1.92-15.19c-2-4.13-13.25-22.13-20.38-27.18-6.69-4.75-14.93 0-18 4.2-8.77 12.14-14.66 36.43-18.54 63.16Z"
      style={{
        fill: "#ffc727",
      }}
    />
    <path
      d="M102.89 144.59a11.36 11.36 0 0 0-2.62 1.38 9.9 9.9 0 0 0 2.89-.66 10.46 10.46 0 0 0 2.62-1.38 11.15 11.15 0 0 0-2.89.66Zm-12.24 35.3a10.25 10.25 0 0 0-2.65 1.37 11.43 11.43 0 0 0 5.5-2 10.7 10.7 0 0 0-2.85.63Zm-19.29-21.45c-.08.28-.16.56-.23.85a9.65 9.65 0 0 0 2.2-1.21 8 8 0 0 0-1.97.36Zm45.7 20.43a9.93 9.93 0 0 0-2.61 1.38 10.54 10.54 0 0 0 2.87-.67 9.83 9.83 0 0 0 2.62-1.38 10.18 10.18 0 0 0-2.88.67ZM68 180.82a10.53 10.53 0 0 0-1.19-2.34c0 .17-.06.34-.1.52a11.56 11.56 0 0 0 .58 2.09 10 10 0 0 0 1.38 2.62 10 10 0 0 0-.67-2.89Zm34.27-14.92a10.11 10.11 0 0 0-1.37-2.62 10.18 10.18 0 0 0 .67 2.88 9.83 9.83 0 0 0 1.38 2.62 9.93 9.93 0 0 0-.71-2.88Zm19.27 28.34a9.83 9.83 0 0 0-1.38-2.62 10.7 10.7 0 0 0 .67 2.88h.79c-.04-.07-.07-.16-.11-.26Zm-31.42-60.52a10.46 10.46 0 0 0-1.37-2.6 11.21 11.21 0 0 0 2 5.48 10.24 10.24 0 0 0-.63-2.88Zm-10 34.72a10.12 10.12 0 0 0-2.83-.87 10.49 10.49 0 0 0 2.51 1.56 10.3 10.3 0 0 0 2.82.88 10 10 0 0 0-2.52-1.57Zm36.56-8.44a10.68 10.68 0 0 0-2.84-.88 10.9 10.9 0 0 0 2.51 1.58 10.64 10.64 0 0 0 2.82.87 10.22 10.22 0 0 0-2.49-1.57ZM77 142.11l-.27.62a8.51 8.51 0 0 0 2 .53 8.08 8.08 0 0 0-1.73-1.15Zm27.62-10.54a7.08 7.08 0 0 0-.8-.16 8.86 8.86 0 0 0 1.72 1.17c-.33-.35-.64-.68-.94-1.01Zm-2.23 58a11.1 11.1 0 0 0-.88 2.83 10.34 10.34 0 0 0 1.57-2.51 10.77 10.77 0 0 0 .88-2.82 10.47 10.47 0 0 0-1.59 2.49Zm13.94-42.33a6.85 6.85 0 0 0-.22 1 5.34 5.34 0 0 0 .48-.61c-.11-.13-.2-.26-.28-.4Zm-36.57 45a11 11 0 0 0-.87 2.78 10.28 10.28 0 0 0 1.55-2.46 10.94 10.94 0 0 0 .87-2.83 10.15 10.15 0 0 0-1.57 2.5Zm8.45-39.08a10.61 10.61 0 0 0-.88 2.83 11.56 11.56 0 0 0 2.45-5.33 11.15 11.15 0 0 0-1.59 2.49Z"
      style={{
        fill: "#fff",
      }}
    />
    <path
      d="M108.7 167.18a62.38 62.38 0 0 0-9 1.66c-1.47.41-2.9.88-4.33 1.38-.71.25-1.43.48-2.15.7a9.79 9.79 0 0 1-2.32.49.06.06 0 0 0 0 .11 16.72 16.72 0 0 0 2.24-.09 17.12 17.12 0 0 0 2.13-.44c1.49-.4 3-.87 4.44-1.28 3-.83 6-1.67 9-2.28.18-.03.14-.27-.01-.25ZM116.27 169.72a67.92 67.92 0 0 0-7.55-.21c-1.26 0-2.5.15-3.76.3-.6.07-1.19.15-1.79.24s-1.29.28-2 .37c-.07 0-.07.11 0 .11.62-.07 1.26 0 1.88-.06l1.88-.08c1.26-.06 2.51-.1 3.77-.17 2.51-.13 5-.24 7.53-.29.18 0 .17-.2.04-.21Z"
      style={{
        fill: "#263238",
      }}
    />
    <path
      d="M89.09 128c.27 1.14 8.4 10 13.32 8.1 1.82-.72-.85-8.1-.85-8.1l2.23-10.27-12.91-8.13S89 127.48 89.09 128Z"
      style={{
        fill: "#ad6359",
      }}
    />
    <path
      d="M90.2 116.28a20 20 0 0 0 11.48 11.11l2.11-9.69-12.91-8.09s-.31 3.01-.68 6.67Z"
      style={{
        fill: "#263238",
      }}
    />
    <path
      d="M116.64 101.49c2.83 17-7 20.58-10.68 21.19-3.32.55-14.71 2-19.27-14.59s2.43-23.27 10-24.93 17.12 1.35 19.95 18.33Z"
      style={{
        fill: "#ad6359",
      }}
    />
    <path
      d="M111.93 97.79h-1.18a1.94 1.94 0 0 1-1.21-.27.6.6 0 0 1-.13-.73 1.51 1.51 0 0 1 1.41-.62 2.24 2.24 0 0 1 1.51.52.65.65 0 0 1-.4 1.1ZM100.48 100c.39-.12.73-.3 1.1-.45a2 2 0 0 0 1-.68.61.61 0 0 0-.14-.73 1.49 1.49 0 0 0-1.54-.08 2.25 2.25 0 0 0-1.23 1 .66.66 0 0 0 .81.94ZM103.68 103.87s-.08.07-.06.12c.27 1.14.39 2.49-.57 3.09v.06c1.25-.44 1.07-2.23.63-3.27Z"
      style={{
        fill: "#263238",
      }}
    />
    <path
      d="M102.41 102.89c-1.88.24-1.25 4 .48 3.75s1.11-3.96-.48-3.75Z"
      style={{
        fill: "#263238",
      }}
    />
    <path
      d="M101.71 103.2c-.29.27-.55.7-.93.8s-.86-.21-1.22-.54c0 0-.06 0-.06.05.11.72.51 1.41 1.29 1.39s1.12-.74 1.17-1.49c.04-.14-.13-.31-.25-.21ZM110.47 102.42s.1 0 .11.08c.14 1.17.51 2.47 1.61 2.69v.07c-1.3.02-1.77-1.72-1.72-2.84Z"
      style={{
        fill: "#263238",
      }}
    />
    <path
      d="M111.31 101c1.84-.43 2.58 3.28.88 3.68s-2.42-3.27-.88-3.68Z"
      style={{
        fill: "#263238",
      }}
    />
    <path
      d="M112.14 101.13c.33.14.69.44 1 .39s.64-.51.82-1h.06c.16.71.08 1.49-.58 1.76s-1.17-.27-1.48-.94c-.02-.04.04-.26.18-.21ZM105.55 113.48c.3.25.61.61 1 .61a3 3 0 0 0 1.24-.38s.08 0 .05.05a1.58 1.58 0 0 1-1.43.75 1.28 1.28 0 0 1-1-1c.01-.04.1-.07.14-.03ZM109.85 108.41a25.19 25.19 0 0 1 .57 2.52c0 .08-.18.14-.46.19a3.93 3.93 0 0 1-4-1c-.07-.07 0-.17.11-.13a5.9 5.9 0 0 0 3.69.55c0-.23-.9-2.89-.77-2.91a7.24 7.24 0 0 1 1.91.17c-.87-3.58-2.31-7-3.12-10.56a.11.11 0 0 1 .21-.08 59.34 59.34 0 0 1 3.84 11.23c.17.51-1.64.12-1.98.02Z"
      style={{
        fill: "#263238",
      }}
    />
    <path
      d="M109.69 110.74a4.58 4.58 0 0 1-1.49 1.8 2.07 2.07 0 0 1-1.21.35c-.94 0-1.15-.85-1.14-1.58a5.08 5.08 0 0 1 .15-1.16 6 6 0 0 0 3.69.59Z"
      style={{
        fill: "#263238",
      }}
    />
    <path
      d="M108.2 112.54a2.07 2.07 0 0 1-1.21.35c-.94 0-1.15-.85-1.14-1.58a2.15 2.15 0 0 1 2.35 1.23Z"
      style={{
        fill: "#ff9abb",
      }}
    />
    <path
      d="M103.94 85.78a7.66 7.66 0 0 1 .25 4.49c-1.43 4-6.16 3.51-7.58 5.19s-.51 4.49-1.7 6.06c-1.65 2.17-4.26 1.67-4.43 3s-.61 5.7-2.24 6.41-12.33-26.67 9.86-28.06c0 0 2.91-1.56 7.86.33 5.46 2.1 8.61 10.44 8.61 10.44s-.12-.1-.94-.69c-1.17-.84-1.67-1.67-2.52-2.2-1.32-.84-2-.4-3.33-1.21a14.51 14.51 0 0 1-3.84-3.76Z"
      style={{
        fill: "#263238",
      }}
    />
    <path
      d="M103.48 84.58a15 15 0 0 1 1 3.33 6.32 6.32 0 0 1-.12 3.35A4.59 4.59 0 0 1 102 93.5c-1 .5-2.16.73-3.25 1.3a3.6 3.6 0 0 0-1.36 1.27 4.49 4.49 0 0 0-.47 1.78 6.23 6.23 0 0 1-.91 3.2 3.8 3.8 0 0 1-2.83 1.55c-1.12.12-2.38-.07-3.41.54 1.08-.52 2.25-.24 3.43-.27a4.14 4.14 0 0 0 3.14-1.56 6.23 6.23 0 0 0 1.07-3.4 4.2 4.2 0 0 1 .43-1.58 2.92 2.92 0 0 1 1.18-1c1-.54 2.13-.8 3.2-1.33a6.24 6.24 0 0 0 1.48-1 3.62 3.62 0 0 0 1-1.52 6.58 6.58 0 0 0 0-3.55 15.67 15.67 0 0 0-1.22-3.35Z"
      style={{
        fill: "#263238",
      }}
    />
    <path
      d="M104 85.55a12.62 12.62 0 0 0 1.39 3 5.77 5.77 0 0 0 2.47 2.22 8.11 8.11 0 0 0 1.59.44 2.61 2.61 0 0 1 1.28.68 8.25 8.25 0 0 0 1.1 1.21 3.67 3.67 0 0 0 1.49.68 4.13 4.13 0 0 1-1.31-.88 8.51 8.51 0 0 1-1-1.28 2.84 2.84 0 0 0-1.47-.91 8.93 8.93 0 0 1-1.51-.44 6.14 6.14 0 0 1-2.33-2 23.9 23.9 0 0 1-1.7-2.72Z"
      style={{
        fill: "#263238",
      }}
    />
    <path
      d="M90.14 108.69s-4.42-4.84-6.66-3.19 1.57 9 4.55 9.68a2.91 2.91 0 0 0 3.66-2.06Z"
      style={{
        fill: "#ad6359",
      }}
    />
    <path
      d="M84.62 107.58v.07c2.09.55 3.38 2.26 4.37 4.07a1.61 1.61 0 0 0-2.44-.12s0 .12.07.1a1.79 1.79 0 0 1 2 .36 8.55 8.55 0 0 1 1.14 1.46c.12.16.43 0 .33-.17-.27-2.59-2.71-5.88-5.47-5.77Z"
      style={{
        fill: "#263238",
      }}
    />
    <path
      d="M88.18 130.06c6.09 1.08.49 35.71-11.34 35s3.94-36.3 11.34-35Z"
      style={{
        fill: "#ad6359",
      }}
    />
    <path
      d="M82.11 147.32c1.75 25.89 9.44 41.33 14.56 44.28 7.63 4.4 18.41-11 18.06-12.45-2.17-9.18-10.55-25.3-19.41-41.63s-14.03-2.52-13.21 9.8Z"
      style={{
        fill: "#ad6359",
      }}
    />
    <path
      d="M83.83 160.92A45.09 45.09 0 0 1 82 146.65c.35 4.72 1.28 9.57 1.8 14.27Z"
      style={{
        fill: "#263238",
      }}
    />
    <path
      d="M81.27 148.15c.5 1.41.56 2.83 1.14 4.19-1.17-1-1.34-2.76-1.14-4.19Z"
      style={{
        fill: "#263238",
      }}
    />
    <path
      d="M98.06 192.18c3.35 1.83 11.42 1.18 36.13-10.57 3.42-1.63-1.56-28.85-5.3-27.3-4.71 1.95-19.58 9.54-20.81 10.33-10.35 6.69-14.08 25.29-10.02 27.54Z"
      style={{
        fill: "#ad6359",
      }}
    />
    <path
      d="M166.37 145.3c.76 3-9.3 6.26-9.3 6.26s2.78 1 3.33 3.08c.63 2.37-2.48 5.15-2.48 5.15a7.36 7.36 0 0 1 2.06 3.79c.37 2.32-2.79 4.85-2.79 4.85a6.4 6.4 0 0 1-.3 4.47c-1.83 3.69-7.89 6.61-11.8 7.49-4.18.93-10.85 2.13-13.58 2.54l-7.59-26.4s15.77-9.87 20.42-10.88c4.08-.88 20.94-4.65 22.03-.35Z"
      style={{
        fill: "#ad6359",
      }}
    />
    <path
      d="M157.05 151.56a53.94 53.94 0 0 0-12.67 3.4c-.09 0 0 .18.05.14 4-1.51 8.58-2 12.66-3.34a.1.1 0 0 0-.04-.2ZM157.81 159.71a11.08 11.08 0 0 0-3 .38c-1 .2-2.07.43-3.1.67q-3.09.72-6.14 1.6c-.09 0-.07.17 0 .14 2.06-.47 4.12-.92 6.19-1.31l3.12-.56a13.25 13.25 0 0 0 2.92-.64.15.15 0 0 0 .01-.28ZM157.21 168.42a7.79 7.79 0 0 0-2.64.48l-2.81.7c-1.88.46-3.75.91-5.64 1.3-.09 0-.07.17 0 .15 1.92-.39 3.84-.75 5.76-1.15l2.82-.61a7.5 7.5 0 0 0 2.51-.78v-.09ZM99.61 178.7c.82-5.84 3.91-11.94 9.33-14.7-.56.51-1.18.9-1.69 1.45-3.78 3.55-6 8.39-7.64 13.25Z"
      style={{
        fill: "#263238",
      }}
    />
    <path
      d="M414 280.45s23.1-3.23 17.7-31.11c-.02 0-25.83 5.79-17.7 31.11Z"
      style={{
        fill: "#ffc727",
      }}
    />
    <path
      d="M414 280.45s23.1-3.23 17.7-31.11c-.02 0-25.83 5.79-17.7 31.11Z"
      style={{
        opacity: 0.1,
      }}
    />
    <path
      d="M415.14 274.63c.46-1.41 1-2.79 1.58-4.15l.06-.53.09-1.15c.07-.83.12-1.67.17-2.5.1-1.66.2-3.33.23-5a.07.07 0 0 1 .14 0v5c0 .83-.08 1.67-.14 2.5v.55a49.38 49.38 0 0 1 4.63-7.92c.8-1.11 1.63-2.17 2.53-3.2s1.89-2.06 2.82-3.1c.06-.07.16 0 .1.1a41.45 41.45 0 0 0-4.45 5.92c-.7 1.06-1.37 2.15-2 3.26l.22-.08.82-.34 1.89-.71c1.24-.46 2.48-.91 3.71-1.38.08 0 .13.1 0 .13-1.22.49-2.44 1-3.65 1.53l-1.79.77-.9.37a3.52 3.52 0 0 1-.62.22c-.46.83-.92 1.67-1.35 2.53a59.71 59.71 0 0 0-2.82 6.65l-.17.48a14.87 14.87 0 0 1 1.89-.91l2.4-1.09c1.61-.74 3.23-1.5 4.78-2.38a.07.07 0 0 1 .07.13c-1.59.87-3.15 1.79-4.74 2.65-.79.43-1.59.85-2.4 1.25a7.83 7.83 0 0 1-2.17.87 27.24 27.24 0 0 0-1.52 6.55c-.26 3.15-.23 6.33-.3 9.49 0 .06-.08.05-.09 0-.23-2.87-.35-5.76-.37-8.64a25.19 25.19 0 0 1 1.35-7.87Z"
      style={{
        fill: "#263238",
      }}
    />
    <path
      d="M418.7 258.23a28 28 0 0 1 .23 4.92h-.07c-.09-1.63-.11-3.26-.3-4.88-.01-.09.13-.12.14-.04ZM425.31 259.63a17.41 17.41 0 0 0 3-1.46c.07-.05.14.08.07.13a11.71 11.71 0 0 1-3 1.43s-.13-.08-.07-.1ZM413.24 324.73c0-2.56.07-5.11.1-7.66.05-8.48.11-17 .27-25.43q.18-10.09.47-20.19a.1.1 0 0 1 .06-.09v-5.51c0-.05.06-.07.11-.07s.12 0 .12.07v5.53a.09.09 0 0 1 .05.08c.34 12 .65 24 .72 35.93v7.31q.12 11.71.09 23.43v3.73c0 7.15-.08 14.29-.08 21.44 0 .38-.43.58-.88.59s-1.07-.18-1.07-.62c0-7.88-.06-15.76-.05-23.64.07-4.97.05-9.94.09-14.9Z"
      style={{
        fill: "#263238",
      }}
    />
    <path
      d="M422.89 317s11.11-8.23 21.65-2.67 12.2 27 12.2 27-15.48 2.21-25.23-7.07c-9.4-8.97-8.62-17.26-8.62-17.26Z"
      style={{
        fill: "#ffc727",
      }}
    />
    <path
      d="M419.86 317.48a13.26 13.26 0 0 1 6.43-.84 9.07 9.07 0 0 1 1.37-.13l1.56-.12c1.08-.09 2.16-.15 3.24-.23 2.19-.16 4.39-.3 6.58-.52.08 0 .09.13 0 .14-2.16.28-4.32.59-6.49.8-1.11.12-2.23.23-3.35.31l-.81.08c.33.08.66.15 1 .25a26.47 26.47 0 0 1 5 2c.87.16 1.74.4 2.6.61 1.38.32 2.75.68 4.11 1 2.7.71 5.37 1.5 8.05 2.28a.07.07 0 0 1 0 .14c-2.68-.66-5.37-1.26-8.05-1.9-1.3-.31-2.61-.61-3.91-.93-.33-.09-.68-.16-1-.24a32.53 32.53 0 0 1 7.9 6.87 42.91 42.91 0 0 1 5.49 8.65c0 .08-.08.16-.12.08a42.43 42.43 0 0 0-6.64-8.72c0 .15.1.3.14.45.21.65.41 1.3.62 2 .41 1.31.83 2.61 1.22 3.93a.07.07 0 0 1-.14 0c-.47-1.26-.91-2.54-1.36-3.82l-.66-1.87-.33-1c0-.1-.08-.2-.11-.3a39 39 0 0 0-3.94-3.35 29.51 29.51 0 0 0-5.9-3.39l.12.57c.1.51.22 1 .32 1.52.22 1.05.42 2.11.63 3.16.42 2.15.68 4.33 1.08 6.48 0 .09-.12.13-.14 0-.5-2.17-1.14-4.29-1.62-6.46-.24-1.09-.49-2.17-.71-3.26-.11-.5-.21-1-.31-1.52a8.41 8.41 0 0 1-.15-.85l-.61-.25c-2.91-1.08-6.14-1.86-9.24-1.27a9.09 9.09 0 0 0-6.69 5.36c-.1.24-.48.09-.43-.15a8.6 8.6 0 0 1 5.25-5.56Z"
      style={{
        fill: "#263238",
      }}
    />
    <path
      d="M436.87 326.64c.31 1.4.62 2.81.94 4.22a31.66 31.66 0 0 1 .77 4.11s-.07 0-.09 0a32.62 32.62 0 0 1-.94-4.14c-.28-1.39-.55-2.78-.82-4.17a.07.07 0 0 1 .14-.02ZM447.61 330.21c1.42.72 2.79 1.54 4.27 2.12.09 0 0 .18-.06.13a44.69 44.69 0 0 1-4.24-2.19s0-.07.03-.06Z"
      style={{
        fill: "#263238",
      }}
    />
    <path
      d="M420.39 301.85s13.58.87 19.9-8.09 4.89-21.76 4.89-21.76-14.26 1.74-19.92 8.17-4.87 21.68-4.87 21.68Z"
      style={{
        fill: "#ffc727",
      }}
    />
    <path
      d="M414 315.25c.47-1.45 1.05-2.89 1.6-4.31s1.09-2.73 1.69-4.07a82.31 82.31 0 0 1 4.07-8c.95-1.65 2-3.25 3-4.83 0-.24.07-.48.11-.73l.18-1.26c.14-.86.29-1.71.43-2.57.32-1.88.7-3.74 1-5.62 0-.08.16-.08.14 0-.27 1.85-.46 3.71-.72 5.57-.13.91-.24 1.82-.38 2.73-.05.33-.11.66-.16 1a97.66 97.66 0 0 1 6.72-8.72l1-1.11c0-.1.09-.2.13-.31s.2-.52.29-.77c.2-.54.4-1.08.59-1.62.38-1.07.72-2.14 1-3.23a.07.07 0 0 1 .14 0c-.28 1.11-.57 2.22-.89 3.32-.16.54-.33 1.06-.52 1.58l-.1.27c1.74-1.9 3.55-3.72 5.38-5.52.06-.07.16 0 .09.1a98.18 98.18 0 0 0-9.56 11.85 8.8 8.8 0 0 1 1-.26c1-.2 2.1-.35 3.15-.48 2.22-.28 4.42-.56 6.63-.91.08 0 .12.12 0 .13-2.1.42-4.19.89-6.28 1.37-1 .23-2 .42-3 .62a17.51 17.51 0 0 0-2.38.68c-.22.31-.45.62-.67.94-1 1.45-1.95 2.93-2.88 4.42l1.38-.27c1.05-.2 2.1-.39 3.16-.57 2.07-.34 4.14-.7 6.19-1.16a.07.07 0 1 1 0 .13c-2.08.49-4.13 1.06-6.19 1.61-1 .26-2 .51-3 .73l-1.51.32a3.69 3.69 0 0 1-.62.11c-2 3.21-3.84 6.51-5.56 9.87-.76 1.47-1.49 3-2.2 4.47s-1.34 3.11-2 4.68c-.05.29-.54.16-.45-.18Z"
      style={{
        fill: "#263238",
      }}
    />
    <path
      d="M427.91 284c.26-1.29.54-2.58.82-3.87 0-.09.16-.05.14 0-.26 1.27-.5 2.54-.73 3.82a37.82 37.82 0 0 1-.78 3.81 28.7 28.7 0 0 1 .55-3.76ZM435.84 283.66c.63-.31 1.29-.56 2-.82l1-.4.52-.21a2.31 2.31 0 0 0 .58-.25c.1-.08.16.1.06.12a2.09 2.09 0 0 0-.58.24l-.51.23-1 .44a19 19 0 0 1-2 .79c-.1.03-.15-.1-.07-.14Z"
      style={{
        fill: "#263238",
      }}
    />
    <path
      d="M406.49 291.18s-8.22-15.36-20.72-17.73-20.16 10.48-20.16 10.48 9.12 11.65 20.59 13.68 20.29-6.43 20.29-6.43Z"
      style={{
        fill: "#ffc727",
      }}
    />
    <path
      d="M377.39 280.33a33.53 33.53 0 0 1 9.8.11l-.55-.3-2.78-1.42a65 65 0 0 0-5.87-2.87.07.07 0 1 1 .06-.13c1.95.91 4 1.68 5.94 2.58 1 .45 1.95.92 2.91 1.42.61.33 1.3.64 1.9 1a35 35 0 0 1 7.95 2.64l-1.57-1.7c-1.16-1.28-2.31-2.62-3.59-3.78-.06-.06 0-.16.1-.1 1.31 1.19 2.7 2.29 4 3.53.62.6 1.21 1.22 1.78 1.86.29.32.58.65.85 1A33 33 0 0 1 415 306.82c0 .09-.11.14-.13.05a37.9 37.9 0 0 0-9.19-15.56 36.33 36.33 0 0 0-16.68-9.69 36.92 36.92 0 0 0-11.56-1.05.12.12 0 1 1-.05-.24Z"
      style={{
        fill: "#263238",
      }}
    />
    <path
      d="M365.61 283.94s9.12 11.64 20.6 13.67c8.75 1.56 16-3 18.87-5.26l.63-1s-5.91-5-17.11-7.87-22.99.46-22.99.46Z"
      style={{
        opacity: 0.1,
      }}
    />
    <path
      d="M384.65 274.85a31.82 31.82 0 0 1 2.78 1.84 17.92 17.92 0 0 1 2.41 2.2.07.07 0 0 1-.11.1c-.83-.72-1.66-1.44-2.53-2.12a27.32 27.32 0 0 0-2.62-1.9c-.08-.04-.01-.16.07-.12ZM377.79 277.45c.46.2.93.36 1.4.55l1.39.58c.1 0 .05.21-.05.16l-1.39-.56-1.39-.59c-.09-.04-.05-.17.04-.14Z"
      style={{
        fill: "#263238",
      }}
    />
    <path
      d="M408.13 310.49s-2.2 15.23-13.65 20.56-25.41 0-25.41 0 5.49-32.95 39.06-20.56Z"
      style={{
        fill: "#ffc727",
      }}
    />
    <path
      d="M377 321.14c1.06-.12 2.11-.3 3.15-.49l1.54-.29.8-.16.93-.86a46 46 0 0 1 7-5.07 36.85 36.85 0 0 1 4.19-2.16h-.21l-3.77.16c-2.52.12-5 .17-7.54.34a.07.07 0 0 1 0-.14c2.52-.17 5-.45 7.55-.67l3.66-.32 1.89-.17.48-.05c.66-.24 1.31-.47 2-.68a17.9 17.9 0 0 1 9.7-.54c2.88.74 5.75 2.63 6.5 5.67 0 .1-.14.17-.18.07-1.08-2.54-3.89-3.82-6.44-4.34a15.27 15.27 0 0 0-5.18-.11 12.6 12.6 0 0 1-.58 2.31c-.32 1.07-.63 2.14-.95 3.21-.65 2.14-1.37 4.26-2 6.4a.07.07 0 0 1-.14 0c.53-2.14 1-4.29 1.5-6.44.25-1 .52-2.1.78-3.15a16.87 16.87 0 0 1 .57-2.16 27.26 27.26 0 0 0-3 .7 44.85 44.85 0 0 0-5.19 1.9c-.17 1.09-.41 2.16-.66 3.23-.31 1.35-.66 2.68-1.08 4a.07.07 0 1 1-.13 0 2 2 0 0 1 .05-.24c.26-1.24.53-2.48.79-3.73.22-1 .41-2 .63-3-1.42.64-2.82 1.34-4.17 2.11 0 .31-.11.63-.15.91-.09.53-.18 1.05-.28 1.57-.21 1.17-.45 2.34-.73 3.5a54.82 54.82 0 0 1-2 6.63.05.05 0 0 1 0 .08l-.06.08c0 .06-.13 0-.12-.07.53-2.26 1.14-4.5 1.63-6.76.25-1.13.5-2.26.73-3.4.11-.56.21-1.13.32-1.7 0-.16.05-.34.08-.51a46.67 46.67 0 0 0-4.46 3 48.54 48.54 0 0 0-6.82 6.23c-.09.09-.25 0-.17-.13a41.27 41.27 0 0 1 2.73-3.33c.57-.62 1.17-1.22 1.78-1.8h-.19l-1.61.25c-1.06.14-2.12.24-3.19.36-.07-.09-.11-.23.02-.24Z"
      style={{
        fill: "#263238",
      }}
    />
    <path
      d="m385 326.31.06-.4a4.67 4.67 0 0 0 .14-.5c.23-1 .43-2 .61-3.07a.07.07 0 0 1 .13 0 12.56 12.56 0 0 1-.87 4s-.09 0-.08 0ZM394.59 326.06a.07.07 0 0 1 .07-.06c.32-1.35.63-2.7.91-4.06.14-.71.29-1.42.43-2.14.07-.38.15-.77.21-1.16a3.43 3.43 0 0 1 .25-1 .07.07 0 0 1 .13 0 6.86 6.86 0 0 1-.29 2.05c-.14.74-.28 1.48-.45 2.22-.33 1.5-.7 3-1.13 4.48 0 .08-.16.06-.15 0s.01-.22.02-.33ZM378 316.76c2.1-.29 4.19-.59 6.28-.84.09 0 .13.12 0 .13-2.09.31-4.19.57-6.28.85 0 .01-.09-.13 0-.14Z"
      style={{
        fill: "#263238",
      }}
    />
    <path
      d="M414 274.78s7-30.74-26-43.18c0 0-9.18 40.46 26 43.18Z"
      style={{
        fill: "#ffc727",
      }}
    />
    <path
      d="m406.87 257.35-.36-.22c-.62-.34-1.24-.7-1.87-1l-3.83-2.15c-2.52-1.41-5-2.87-7.54-4.25a.07.07 0 1 1 .07-.12c2.54 1.38 5.13 2.67 7.69 4l3.78 2 1.55.81a77.86 77.86 0 0 0-3.57-6.11c-1.73-2.63-3.62-5.14-5.59-7.59-.09-.11.06-.26.16-.16a52.16 52.16 0 0 1 7.64 9.37v-.32c0-.77-.06-1.53-.07-2.3 0-1.5.05-3 0-4.5a.07.07 0 0 1 .14 0c.06 1.48.24 2.95.32 4.43 0 .73.08 1.47.1 2.21 0 .4.05.85 0 1.29.68 1.08 1.34 2.18 2 3.29a57.7 57.7 0 0 1 3 6.19c0-.76.08-1.53.12-2.29.1-1.69.3-3.36.38-5.05a.07.07 0 1 1 .14 0v5.05c0 .84-.05 1.68-.11 2.52l-.06.94a56.72 56.72 0 0 1 2.5 8.45 93.51 93.51 0 0 1 1.23 9.28 50 50 0 0 0-1.75-8.28c-.41-1.45-.84-2.89-1.31-4.32-1.37-.65-2.69-1.46-4-2.2l-4.15-2.26c-2.75-1.51-5.5-3.05-8.35-4.39-.08 0 0-.15.08-.12 2.88 1.31 5.78 2.55 8.61 4 1.4.7 2.79 1.46 4.16 2.23 1.15.65 2.33 1.3 3.42 2-.32-1-.65-1.91-1-2.85a81.66 81.66 0 0 0-3.53-7.58Z"
      style={{
        fill: "#263238",
      }}
    />
    <path
      d="M409.65 250.32c0-.09.15-.09.14 0-.12 1.75-.18 3.51-.36 5.26a.08.08 0 0 1-.16 0c.06-1.77.25-3.51.38-5.26ZM393.81 256.19c2.07.83 4.16 1.62 6.21 2.48.06 0 0 .12 0 .1-2.09-.79-4.15-1.64-6.23-2.45-.1-.03-.06-.17.02-.13ZM390.68 242a54.25 54.25 0 0 1 5.87 3.15c.1.06 0 .21-.09.15-1.92-1.12-3.87-2.19-5.86-3.18-.08-.03-.01-.12.08-.12Z"
      style={{
        fill: "#263238",
      }}
    />
    <path
      d="M391.17 341.26h47.63v50.21h-47.63z"
      style={{
        fill: "#455a64",
      }}
      transform="rotate(180 414.99 366.36)"
    />
    <path
      d="M439.65 359.02h2.44v103.17h-2.44zM388.15 359.02h2.44v103.17h-2.44zM412.6 359.02h2.44v103.17h-2.44z"
      style={{
        fill: "#263238",
      }}
    />
    <path
      d="M389.37 388.25h51.5v6.95h-51.5z"
      style={{
        fill: "#263238",
      }}
      transform="rotate(180 415.12 391.725)"
    />
    <path
      d="M166.41 56.12a24 24 0 0 1-38.29 19.27l-11.76 3 4.9-11a23.76 23.76 0 0 1-2.84-11.32 24 24 0 0 1 48 0Z"
      style={{
        fill: "#fff",
      }}
    />
    <path
      d="M166.41 56.12c.17 13.88-12.28 25.34-26.08 24.15a24.28 24.28 0 0 1-12.42-4.6l.3.06-11.74 3.09-.88.23.37-.84 4.86-11v.42c-5.53-9.83-2.84-23.13 5.9-30.18 15.73-13 39.67-1.77 39.68 18.63Zm0 0c.08-15.33-14.93-27-29.76-23C122 36.77 114.44 54 121.68 67.21l.11.22-.09.21-4.94 10.93-.5-.61L128 75h.17a23.38 23.38 0 0 0 15.45 4.85c12.49-.3 22.85-11.28 22.76-23.73Z"
      style={{
        fill: "#263238",
      }}
    />
    <path
      d="m138.53 70.4-10.76-10.88 3.62-3.57 6.28 6.35 13.05-20.46 4.28 2.74-16.47 25.82z"
      style={{
        fill: "#ffc727",
      }}
    />
  </svg>
)
export default React.memo(ContractIllustration2);
